

<li class="nav-item" *ngIf="showFilter" (click)="elementService.openCloseTreeview($event)">
  <a class="nav-link">
    <i class="nav-icon fas fa-bars"></i>
    <p>
      Metadados
      <i class="right fas fa-angle-left"></i>
    </p>
  </a>
  <ul class="nav nav-treeview">
    <li class="nav-item">
      <button
        type="submit"
        class="btn bg-gradient-info nav-link"
        (click)="clearFilters()">
        <i class="fa fa-eraser"></i> Limpar Filtros
      </button>
    </li>
    <li *ngFor="let node of dataSource.data" [ngClass]="openCloseTreeview(node)" (click)="treeviwNavControl(node)">
      <!--Filtros com checkbox-->
      <a *ngIf="node.tipo!=='Data'" class="nav-link" id="{{node.solrName}}">
        <p>{{node.name}}
          <i class="right fas fa-angle-left"></i>
        </p>
      </a>
      <ul *ngIf="node.tipo!=='Data'" class="nav nav-treeview">
        <li class="nav-item metadata-filter-search-wrapper">
          <div *ngIf="isLoading" class="spinner-container">
            <div class="custom-spinner"></div>
          </div>
          <div *ngIf="node.tipo!=='Numero'"class="input-group">
            <input class="form-control form-control-sidebar" type="search" placeholder="filtrar dados" [(ngModel)]="node.inputText" (ngModelChange)="this.searchTextUpdate.next(node)">
          </div>
          <div *ngIf="node.tipo=='Numero' && node.maxValue && node.gap"class="input-group">
            <mat-slider min="node.minValue" [max]="node.maxValue" [step]="node.gap" showTickMarks discrete [displayWith]="formatLabel">
              <input matSliderStartThumb [(ngModel)]="node.startRange" (ngModelChange)="this.rangeUpdate.next(node)" >
              <input matSliderEndThumb [(ngModel)]="node.endRange" (ngModelChange)="this.rangeUpdate.next(node)">
            </mat-slider>
          </div>
        </li>
        <li *ngFor="let field of node.children" class="nav-item" (click)="getNode(field)">
          <a class="nav-link">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="field.selected"  />
              <p 
                            [matTooltip]="field.name"
                            [matTooltipPosition]="'above'"
                            matTooltipHideDelay="2" 
                            class="asideFilter"> {{field.name}}
                        </p>

            </div>
            
          </a>
        </li>
        <div *ngIf="node.open && node.isEmpty && node.tipo!='Numero'">
          <p style="text-align: center; color: #c2c7d0;">Sem dados</p>
        </div>
      </ul>
      <!-- Data de processamento-->
      <a *ngIf="node.tipo==='Data'" class="nav-link">
        <p>{{node.name}}
          <i class="right fas fa-angle-left"></i>
        </p>
      </a>
      <ul *ngIf="node.tipo==='Data'" class="nav nav-treeview">
        
        <li class="nav-item" (click)="elementService.openCloseTreeview($event)">
          <!-- <a href="#" class="nav-link">
            <i class="far fa-dot-circle nav-icon"></i>
            <p>Level 3</p>
          </a> -->
          

          <button id="daterange-btn-{{node.solrName}}" 
              class="btn bg-gradient-info nav-link"
            >
            
            <span></span>
            <i class="float-right fa fa-caret-down"></i>
          </button>

          <button type="button" class="btn bg-gradient-danger nav-link" id="removeFilter-btn-{{node.name}}" (click)='removeDateRangeFilter()'>
            <span>
            Remover Filtro
            </span>
          </button>
        </li>
      </ul>
    </li>
  
  </ul>
</li>